import { render, staticRenderFns } from "./NeedsStudent.vue?vue&type=template&id=16703d2e&scoped=true"
import script from "./NeedsStudent.vue?vue&type=script&lang=js"
export * from "./NeedsStudent.vue?vue&type=script&lang=js"
import style0 from "./NeedsStudent.vue?vue&type=style&index=0&id=16703d2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16703d2e",
  null
  
)

export default component.exports